export default __webpack_public_path__ + "static/media/sangria.da925f48.png";